import getDatabaseColors from '@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors';
import getDatabaseListStyles from '@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseListStyles';

common.View.create('crud::form.inputs.Richtext', {
    ckEditor: null,
    allowBlurOnce: false,
    dbColors: [],

    onDOMLoad() {
        this.initCkeditor();
    },

    async initCkeditor() {
        // Get textarea.
        let textarea = this.element.find('textarea').get(0);

        // Init Ckeditor.
        CKEDITOR.replace(textarea, await this.getOptions());
    },

    async getOptions() {
        let options = {

            contentsCss: [
                '/vendor/@fortawesome/fontawesome-pro/css/all.min.css',
                '/css/website.tw.css', '/css/website.css', 
                '/api/css/theme.css', '/api/css/dynamic-list-styles.css'
            ],

            filebrowserImageBrowseUrl: '/admin/filemanager?type=Images',
            filebrowserImageUploadUrl: '/admin/filemanager/upload?type=Images&_token=',
            filebrowserBrowseUrl: '/admin/filemanager?type=Files',
            filebrowserUploadUrl: '/admin/filemanager/upload?type=Files&_token=',

            extraPlugins: 'link,colorbutton,sourcedialog,justify,embed,autoembed,dialogadvtab',

            // Needed so CKeditor doesn't remove image advanced by default
            removeDialogTabs: '',

            embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',

            colorButton_colors: await this.initDatabaseColors(),

            stylesSet: await this.initDatabaseListStyles(),

            // Toolbar
            toolbarGroups: [
                { name: 'document', groups: ['mode', 'document', 'doctools', 'source', 'embed'] },
                { name: 'clipboard', groups: ['clipboard', 'undo'] },
                { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
                { name: 'forms', groups: ['forms'] },
                { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
                { name: 'link', groups: ['links'] },
                { name: 'insert', groups: ['insert'] },
                { name: 'styles', groups: ['styles', 'colors'] },
            ],
            removeButtons: 'PasteFromWord,Paste,Copy,Replace,Find,SelectAll,Source,Scayt,Form,Checkbox,Radio,Textarea,Select,TextField,Button,HiddenField,Save,Preview,Print,NewPage,Templates,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,JustifyBlock,Language,BidiRtl,BidiLtr,Anchor,Flash,HorizontalRule,PageBreak,Iframe,FontSize,Font,BGColor,ShowBlocks,Maximize,About,SpecialChar',

            // TODO Enable, but will break link plugin - the button disappears.
            //allowedContent: 'ul li a[*] b strong i h2 h3 h4',
            extraAllowedContent: 'iframe[*]',

            format_tags: 'p;h2;h3;h4;h5',

            language: 'nl',

            versionCheck: false,

            on: {
                instanceReady: this.onCkeditorLoaded.bind(this),
            },
        };

        // Apply app options.
        options = require('@resources/js/galaxy/crud/form/inputs/richtext.js')(options);

        // Apply input specific options
        let elementOptions = this.element.find('textarea').data('ckeditorStyle');
        if (elementOptions) {
            try {
                // Try to load the file from resources
                options = require('@resources/js/galaxy/crud/form/inputs/' + elementOptions + '.js')(options);
            } catch (e) {
                // Check if the file exists within Galaxy
                options = require('@galaxy/modules/Crud/resources/js/form/inputs/richtext/' + elementOptions + '.js')(options);
            }
        }

        return options;
    },

    async initDatabaseListStyles() {
        let databaseListStyles = (await getDatabaseListStyles(true)).data;

        let stylesSetLists = [];

        for (const [key, value] of Object.entries(databaseListStyles)) {
            stylesSetLists.push(
                { 
                    name: 'Lijst [' + value.name + ']',
                    element: 'ul', 
                    attributes: { 'class': 'checklist-icon-' + value.unicode + '-' + value.weight }
                },
            );
        }

        return stylesSetLists;
    },

    async initDatabaseColors() {
        // Grab database colors
        let databaseColors = (await getDatabaseColors(true)).data;

        // Initialize empty array
        let colorsToCkeditor = [];

        // Add colors from database to array, and convert array to flat items
        $.each(databaseColors || [], function (item, value) {
            if (typeof value !== 'string') {
                for (let [key, val] of Object.entries(value)) {
                    colorsToCkeditor.push(val);
                }
            } else {
                colorsToCkeditor.push(value);
            }
        });

        // Filter duplicates
        let colors = [...new Set(colorsToCkeditor)];

        let formattedColors = [];

        for (const colorObj of colors) {
            for (const [key, value] of Object.entries(colorObj)) {
                let colorValue = value.replace('#', '');
                formattedColors.push(key + '/' + colorValue);
            }
        }

        // Return colors
        return [
            'white/ffffff',
            'black/000000',
            ...formattedColors
        ].join(',');
    },

    onCkeditorLoaded(event) {
        this.ckEditor = event.editor;
    },
});
